module.exports = __webpack_public_path__ + "img/Motorisation sans butée centrale.6185b41d.jpg";